import React from "react";
import MenuButton from "../MenuButton/MenuButton";
import { useFormik } from "formik";
import { salaryFilter } from "../schemas";
import useTable from "../../hooks/useTable";
import useSortableData from "../../hooks/useSortableData";
import Pagination from "react-js-pagination";
import { useState } from "react";
import UserServices from "../../UserServices/UserServices";
import { useEffect } from "react";
import { useContext } from "react";
import { NoteState } from "../../context/notes/NoteState";
import CurrencyFormat from "react-currency-format";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import $ from "jquery";
import moment from "moment";

const StaffCommision = () => {
  const { state } = useContext(NoteState);
  const { branch_id, role, UId } = state;

  // Get the current date
  // const currentDate = new Date();

  // currentDate.setDate(1);

  // const year = currentDate.getFullYear();
  // const month = currentDate.getMonth() + 1;

  // const formattedMonth = month < 10 ? `0${month}` : month;
  const currentDate = new Date();
  currentDate.setDate(1);

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;

  const formattedMonth = month < 10 ? `0${month}` : month;

  // Calculate the start date by subtracting one month
  const previousMonth = month === 1 ? 12 : month - 1;
  const previousYear = month === 1 ? year - 1 : year;
  const formattedPreviousMonth =
    previousMonth < 10 ? `0${previousMonth}` : previousMonth;
  const startDate = `${previousYear}-${formattedPreviousMonth}-26`;

  const [loading, setLoading] = useState(false);
  const [myData, setMyData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);

  const [limit, setLimit] = useState("25");
  const [totalResults, setTotalResults] = useState("0");
  const [totalPages, setTotalPages] = useState("1");
  const [exportLink, setExportLink] = useState("");
  const [trainerName, setTrainerName] = useState([]);
  const [periodRange, setPeriodRange] = useState({
    start_date: startDate,
    end_date: `${year}-${formattedMonth}-25`,
  });

  // const getSalary = async (e) => {
  //   if (Date.parse(values.sdate) <= Date.parse(values.edate)) {
  //     setLoading(true);
  //     try {
  //       const responce = await UserServices.getLatestStaffCommision(
  //         branch_id,
  //         values,
  //         limit,
  //         "!"
  //       );
  //       let myDataarr;

  //       if (responce.status === 200) {
  //         setExportLink(
  //           process.env.REACT_APP_API_Link +
  //             "/auth/export-salaries?branch_id=" +
  //             branch_id +
  //             "&start_date=" +
  //             values.edate +
  //             "-" +
  //             values.sdate +
  //             "-01" +
  //             "&end_date=" +
  //             values.edate +
  //             "-" +
  //             values.sdate +
  //             "-31"
  //         );
  //         myDataarr = responce.data.data;
  //         const res = myDataarr;
  //         const results = [];

  //         res.map((values) => {
  //           results.push({
  //             id: values.id,
  //             name: values.name,
  //             department: values.department,
  //             designation: values.designation,
  //             commission: parseInt(values.commission?.commission),
  //             commission_per: parseInt(values.commission?.commission_per),
  //             gx_commission: parseInt(values.commission?.gx_commission),
  //             pt_commission: parseInt(values.commission?.pt_commission),
  //             pt_commission: parseInt(values.commission?.pt_commission),
  //             small_pt_commission: parseInt(
  //               values.commission?.small_pt_commission
  //             ),
  //             details: values.commission?.details,
  //           });
  //           return null;
  //         });

  //         setMyData([...results]);
  //         setLimit(responce.data.pagination.per_page);
  //         setTotalResults(responce.data.pagination.total_record);
  //         setTotalPages(responce.data.pagination.total_pages);
  //         setCurrentPage(responce.data.pagination.current_page);
  //         setLoading(false);
  //       }
  //     } catch (err) {
  //       if (err.response.status === 404) {
  //         setExportLink();
  //         setTotalResults("0");
  //         setTotalPages("1");
  //         setMyData([]);
  //         setLoading(false);
  //       } else {
  //         setLoading(false);
  //       }
  //     }
  //   } else {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "End date should be greater then start date!",
  //     });
  //   }
  // };
  //adeel
  const generatePdf = (table) => {
    const doc = new jsPDF("p", "mm", "letter");
    const captionText = table.getAttribute("data-caption");
    doc.text(captionText, 10, 10);
    const tableOptions = {
      headStyles: { fillColor: [232, 0, 43], textColor: 255 },
      styles: { fontSize: 5 },
    };
    doc.autoTable({
      html: table,
      ...tableOptions,
    });
    doc.save("staff-commission.pdf");
  };
  //adeel

  const mapCommissionRows = (rows = []) =>
    rows.map((entry) => {
      const commission = entry.commission || {};
      return {
        id: entry.id,
        name: entry.name,
        department: entry.department,
        designation: entry.designation,
        commission: Number(commission.commission ?? 0),
        gross_commission: Number(
          commission.gross_commission ?? commission.commission ?? 0
        ),
        paid_commission: Number(commission.paid_commission ?? 0),
        outstanding_commission: Number(commission.outstanding_commission ?? 0),
        payment_progress: Number(commission.payment_progress ?? 0),
        commission_per: Number(commission.commission_per ?? 0),
        gx_commission: Number(commission.gx_commission ?? 0),
        pt_commission: Number(commission.pt_commission ?? 0),
        small_pt_commission: Number(commission.small_pt_commission ?? 0),
        total_delivered_sessions: Number(
          commission.total_delivered_sessions ?? 0
        ),
        total_payable_no_show_sessions: Number(
          commission.total_payable_no_show_sessions ?? 0
        ),
        total_package_sessions: Number(commission.total_package_sessions ?? 0),
        total_remaining_contract_sessions: Number(
          commission.total_remaining_contract_sessions ?? 0
        ),
        total_client_no_show_sessions: Number(
          commission.total_client_no_show_sessions ?? 0
        ),
        total_trainer_no_show_sessions: Number(
          commission.total_trainer_no_show_sessions ?? 0
        ),
        total_client_cancel_sessions: Number(
          commission.total_client_cancel_sessions ?? 0
        ),
        total_trainer_cancel_sessions: Number(
          commission.total_trainer_cancel_sessions ?? 0
        ),
        formula_guide: commission.formula_guide || "",
        payout_status: commission.payout_status || "unpaid",
        payout_date: commission.payout_date || null,
        details: commission.details || [],
      };
    });

  const updateCommissionState = (response) => {
    setExportLink(
      process.env.REACT_APP_API_Link +
        "/auth/export-salaries?branch_id=" +
        branch_id +
        "&start_date=" +
        values.startdate +
        "&end_date=" +
        values.enddate
    );
    setMyData(mapCommissionRows(response.data.data || []));
    setLimit(response.data.pagination.per_page);
    setTotalResults(response.data.pagination.total_record);
    setTotalPages(response.data.pagination.total_pages);
    setCurrentPage(response.data.pagination.current_page);
    setPeriodRange(
      response.data.period || {
        start_date: values.startdate,
        end_date: values.enddate,
      }
    );
  };

  const fetchCommissionData = async (pageNo = "!", requestLimit = limit) => {
    const response = await UserServices.getLatestStaffCommision(
      branch_id,
      values,
      requestLimit,
      pageNo
    );

    if (response.status === 200) {
      updateCommissionState(response);
    }
  };

  const getSalary = async () => {
    if (Date.parse(values.startdate) > Date.parse(values.enddate)) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "End date should be greater than start date!",
      });
      return;
    }

    setLoading(true);
    try {
      await fetchCommissionData("!", limit);
    } catch (err) {
      if (err?.response?.status === 404) {
        setExportLink("");
        setTotalResults("0");
        setTotalPages("1");
        setMyData([]);
      }
    } finally {
      setLoading(false);
    }
  };

  const markTrainerCommissionPaid = async (trainer) => {
    if (!trainer || trainer.outstanding_commission <= 0) {
      return;
    }

    const paymentPrompt = await Swal.fire({
      title: "Record Commission Payment",
      text: `${trainer.name} - outstanding Rs ${trainer.outstanding_commission}/-`,
      icon: "question",
      input: "number",
      inputLabel: "Enter paid amount",
      inputValue: trainer.outstanding_commission,
      inputAttributes: {
        min: 1,
        max: trainer.outstanding_commission,
        step: 1,
      },
      showCancelButton: true,
      confirmButtonText: "Save Payment",
      inputValidator: (value) => {
        const amount = Number(value);
        if (!amount || amount <= 0) {
          return "Enter a valid paid amount";
        }
        if (amount > trainer.outstanding_commission) {
          return "Paid amount cannot be greater than outstanding commission";
        }
        return null;
      },
    });

    if (!paymentPrompt.isConfirmed) {
      return;
    }

    setLoading(true);
    try {
      const paidAmount = Number(paymentPrompt.value);
      const payload = {
        branch_id,
        trainer_id: trainer.id,
        start_date: periodRange.start_date || values.startdate,
        end_date: periodRange.end_date || values.enddate,
        paid_amount: paidAmount,
        notes:
          paidAmount < trainer.outstanding_commission
            ? "Partial commission payment recorded from commission screen"
            : "Commission paid from commission screen",
      };

      const response = await UserServices.markCommissionPaid(payload);
      await fetchCommissionData(currentPage, limit);

      Swal.fire({
        icon: "success",
        title: "Success",
        text: response?.data?.message || "Commission marked as paid",
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Unable to mark paid",
        text:
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Please try again",
      });
    } finally {
      setLoading(false);
    }
  };

  const getPayoutBadgeClass = (status) => {
    if (status === "paid") {
      return "badge bg-success";
    }
    if (status === "partial") {
      return "badge bg-warning text-dark";
    }
    return "badge bg-secondary";
  };

  const getPayoutRowStyle = (status) => {
    if (status === "paid") {
      return { backgroundColor: "#dff5df" };
    }
    if (status === "partial") {
      return { backgroundColor: "#fff4cc" };
    }
    return {};
  };

  const renderCurrency = (amount) => (
    <CurrencyFormat
      value={amount || 0}
      displayType={"text"}
      thousandSpacing={"2s"}
      thousandSeparator={true}
      prefix={"Rs "}
      suffix={"/-"}
      renderText={(value) => <span>{value}</span>}
    />
  );

  const gymTrainer = async (br_Id) => {
    // var br_Id = e.target.value;
    try {
      const responce = await UserServices.TrainerName(br_Id);

      const res = responce.data.data;
      const results = [];

      res.map((value) => {
        results.push({
          id: value.id,
          first_name: value.first_name,
          last_name: value.last_name,
        });
        return null;
      });
      setTrainerName([{ first_name: "Select Trainer", id: "" }, ...results]);
    } catch (err) {
      console.log(err);
      setTrainerName([]);
    }
  };
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    getSalary();
    gymTrainer(branch_id);
  }, []);

  // const initialValues = {
  //   sdate: formattedMonth,
  //   edate: year,
  //   trainer_id: role === "9" ? UId : "",
  // };
  const initialValues = {
    sdate: formattedMonth,
    edate: year,
    trainer_id: role === "9" ? UId : "",
    startdate: startDate,
    enddate: `${year}-${formattedMonth}-25`,
  };
  //.......................................................................................................................
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: salaryFilter,
    onSubmit: (values) => {
      getSalary();
    },
  });

  const changePagination = (e) => {
    setCurrentPage(e);
    const getPaginationData = async () => {
      setLoading(true);
      try {
        await fetchCommissionData(e, limit);
      } catch (err) {
        if (err?.response?.status === 404) {
          setTotalResults("0");
          setTotalPages("1");
          setMyData([]);
        }
      } finally {
        setLoading(false);
      }
    };
    getPaginationData();
  };
  const changeLimit = (e) => {
    let newLimit = e;
    setLimit(newLimit);
    const getLimitData = async () => {
      setLoading(true);
      try {
        await fetchCommissionData("!", newLimit);
      } catch (err) {
        if (err?.response?.status === 404) {
          setTotalResults("0");
          setTotalPages("1");
          setMyData([]);
        }
      } finally {
        setLoading(false);
      }
    };
    getLimitData();
  };
  const showInstalDetails = (id) => {
    $("#" + id).fadeToggle();
  };

  const Table = ({ data, rowsPerPage }) => {
    const { slice } = useTable(data, 1, rowsPerPage);
    const { items, requestSort, sortConfig } = useSortableData(slice);

    const getClassNamesFor = (name) => {
      if (!sortConfig) {
        return;
      }
      return sortConfig.key === name ? sortConfig.direction : undefined;
    };

    return (
      <>
        <div className="table-responsive mt-3">
          <table
            className="table table-striped table-borderless table-style-1"
            id="report-POS"
            data-caption="Staff Commission"
          >
            <thead>
              <tr>
                <th scope="col" className="no_sort">
                  Sr#
                </th>
                <th
                  scope="col"
                  onClick={() => requestSort("name")}
                  className={getClassNamesFor("name")}
                >
                  Staff Name
                </th>
                <th
                  scope="col"
                  onClick={() => requestSort("department")}
                  className={getClassNamesFor("department")}
                >
                  Department
                </th>
                <th
                  scope="col"
                  onClick={() => requestSort("designation")}
                  className={getClassNamesFor("designation")}
                >
                  Designation
                </th>

                <th
                  scope="col"
                  onClick={() => requestSort("commission_per")}
                  className={getClassNamesFor("commission_per")}
                >
                  PT %
                </th>
                <th
                  scope="col"
                  onClick={() => requestSort("pt_commission")}
                  className={getClassNamesFor("pt_commission")}
                >
                  PT Commission
                </th>

                <th
                  scope="col"
                  onClick={() => requestSort("gx_commission")}
                  className={getClassNamesFor("gx_commission")}
                >
                  Studio Commission
                </th>
                <th
                  scope="col"
                  onClick={() => requestSort("small_pt_commission")}
                  className={getClassNamesFor("small_pt_commission")}
                >
                  SPT Commission
                </th>
                <th
                  scope="col"
                  onClick={() => requestSort("commission")}
                  className={getClassNamesFor("commission")}
                >
                  Gross Commission
                </th>
                <th
                  scope="col"
                  onClick={() => requestSort("paid_commission")}
                  className={getClassNamesFor("paid_commission")}
                >
                  Paid
                </th>
                <th
                  scope="col"
                  onClick={() => requestSort("outstanding_commission")}
                  className={getClassNamesFor("outstanding_commission")}
                >
                  Outstanding
                </th>
                <th
                  scope="col"
                  onClick={() => requestSort("payout_status")}
                  className={getClassNamesFor("payout_status")}
                >
                  Payout Status
                </th>
                <th
                  scope="col"
                  onClick={() => requestSort("payout_date")}
                  className={getClassNamesFor("payout_date")}
                >
                  Payout Date
                </th>
                <th scope="col" className="no_sort">
                  Action
                </th>
                {/* <th
                  scope="col"
                  onClick={() => requestSort("last_month_paid")}
                  className={getClassNamesFor("last_month_paid")}
                >
                  Last Month Paid
                </th> */}
              </tr>
            </thead>
            <tbody>
              {items.length ? (
                items.map((el, index) => (
                  <>
                    <tr key={index} style={getPayoutRowStyle(el.payout_status)}>
                      <td>
                        <div className="d-flex">
                          <span className="ms-2">
                            {currentPage === 1
                              ? index + 1
                              : (currentPage - 1) * limit + index + 1}
                          </span>
                          {el.details?.length ? (
                            <div
                              className="ms-2"
                              onClick={() => {
                                showInstalDetails(el.id);
                              }}
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              <i className="bi bi-chevron-down fw-bold"></i>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </td>
                      <td>
                        <Link to={"/staff-profile/" + el.id}>{el.name}</Link>
                      </td>
                      <td>{el.department}</td>

                      <td>{el.designation}</td>

                      <td>
                        {/* {el.commission_per + "%"} */}
                        <CurrencyFormat
                          value={el.commission_per ? el.commission_per : "0"}
                          displayType={"text"}
                          thousandSpacing={"2s"}
                          thousandSeparator={true}
                          suffix={"%"}
                          renderText={(value) => <span>{value}</span>}
                        />
                      </td>
                      <td>
                        <CurrencyFormat
                          value={el.pt_commission ? el.pt_commission : "0"}
                          displayType={"text"}
                          thousandSpacing={"2s"}
                          thousandSeparator={true}
                          prefix={"Rs "}
                          suffix={"/-"}
                          renderText={(value) => <span>{value}</span>}
                        />
                      </td>

                      <td>
                        <CurrencyFormat
                          value={el.gx_commission ? el.gx_commission : "0"}
                          displayType={"text"}
                          thousandSpacing={"2s"}
                          thousandSeparator={true}
                          prefix={"Rs "}
                          suffix={"/-"}
                          renderText={(value) => <span>{value}</span>}
                        />
                      </td>
                      <td>
                        <CurrencyFormat
                          value={
                            el.small_pt_commission
                              ? el.small_pt_commission
                              : "0"
                          }
                          displayType={"text"}
                          thousandSpacing={"2s"}
                          thousandSeparator={true}
                          prefix={"Rs "}
                          suffix={"/-"}
                          renderText={(value) => <span>{value}</span>}
                        />
                      </td>
                      <td>
                        <CurrencyFormat
                          value={el.gross_commission ? el.gross_commission : "0"}
                          displayType={"text"}
                          thousandSpacing={"2s"}
                          thousandSeparator={true}
                          prefix={"Rs "}
                          suffix={"/-"}
                          renderText={(value) => <span>{value}</span>}
                        />
                      </td>
                      <td>
                        <CurrencyFormat
                          value={el.paid_commission ? el.paid_commission : "0"}
                          displayType={"text"}
                          thousandSpacing={"2s"}
                          thousandSeparator={true}
                          prefix={"Rs "}
                          suffix={"/-"}
                          renderText={(value) => <span>{value}</span>}
                        />
                      </td>
                      <td>
                        <CurrencyFormat
                          value={
                            el.outstanding_commission
                              ? el.outstanding_commission
                              : "0"
                          }
                          displayType={"text"}
                          thousandSpacing={"2s"}
                          thousandSeparator={true}
                          prefix={"Rs "}
                          suffix={"/-"}
                          renderText={(value) => <span>{value}</span>}
                        />
                      </td>
                      <td>
                        {el.payout_status === "paid" ? (
                          <span className={getPayoutBadgeClass(el.payout_status)}>
                            Fully Paid
                          </span>
                        ) : el.payout_status === "partial" ? (
                          <span className={getPayoutBadgeClass(el.payout_status)}>
                            Half/Partial Paid
                          </span>
                        ) : (
                          <span className={getPayoutBadgeClass(el.payout_status)}>
                            Unpaid
                          </span>
                        )}
                        {el.payment_progress > 0 ? (
                          <div style={{ fontSize: "12px", color: "#666" }}>
                            {el.payment_progress}% settled
                          </div>
                        ) : null}
                      </td>
                      <td>
                        {el.payout_date
                          ? moment(el.payout_date).format("DD-MM-YYYY")
                          : "-"}
                      </td>
                      <td>
                        {el.outstanding_commission > 0 ? (
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-success"
                            onClick={() => markTrainerCommissionPaid(el)}
                          >
                            Record Payment
                          </button>
                        ) : (
                          <span className="badge bg-success">Settled</span>
                        )}
                      </td>
                      {/* <td>
                        {el.last_month_paid?.session_count || 0}
                      </td> */}
                    </tr>
                    {el.details?.length ? (
                      <tr
                        className="instalmnt-info table table-striped"
                        id={el.id}
                      >
                        <td colSpan="14">
                          <div className="p-3 bg-light border rounded">
                            <div className="row g-2 mb-3">
                              <div className="col-md-4">
                                <div className="border rounded p-2 bg-white h-100">
                                  <div style={{ fontSize: "12px", color: "#666" }}>
                                    Calculation Rule
                                  </div>
                                  <div style={{ fontWeight: 600, fontSize: "13px" }}>
                                    {el.formula_guide ||
                                      "Line Commission = ceil(Commission Per Session x Payable Sessions)"}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="border rounded p-2 bg-white h-100">
                                  <div style={{ fontSize: "12px", color: "#666" }}>
                                    Delivered
                                  </div>
                                  <div style={{ fontWeight: 700 }}>
                                    {el.total_delivered_sessions || 0}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="border rounded p-2 bg-white h-100">
                                  <div style={{ fontSize: "12px", color: "#666" }}>
                                    Paid No-Show
                                  </div>
                                  <div style={{ fontWeight: 700 }}>
                                    {el.total_payable_no_show_sessions || 0}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="border rounded p-2 bg-white h-100">
                                  <div style={{ fontSize: "12px", color: "#666" }}>
                                    Contract Sessions
                                  </div>
                                  <div style={{ fontWeight: 700 }}>
                                    {el.total_package_sessions || 0}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="border rounded p-2 bg-white h-100">
                                  <div style={{ fontSize: "12px", color: "#666" }}>
                                    Remaining
                                  </div>
                                  <div style={{ fontWeight: 700 }}>
                                    {el.total_remaining_contract_sessions || 0}
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="mb-3" style={{ fontSize: "12px", color: "#555" }}>
                              No-show split: Client {el.total_client_no_show_sessions || 0} / Trainer{" "}
                              {el.total_trainer_no_show_sessions || 0}
                              {" | "}
                              Cancel split: Client {el.total_client_cancel_sessions || 0} / Trainer{" "}
                              {el.total_trainer_cancel_sessions || 0}
                            </div>

                            <div className="table-responsive">
                              <table className="table table-sm table-bordered bg-white mb-2">
                                <thead>
                                  <tr>
                                    <th>Client</th>
                                    <th>Package</th>
                                    <th>Join</th>
                                    <th>Expiry</th>
                                    <th>Contract</th>
                                    <th>Delivered</th>
                                    <th>Client No-Show</th>
                                    <th>Trainer No-Show</th>
                                    <th>Payable No-Show</th>
                                    <th>Payable Sessions</th>
                                    <th>Pkg Ex. GST</th>
                                    <th>Cost / Session</th>
                                    <th>%</th>
                                    <th>Commission / Session</th>
                                    <th>Formula</th>
                                    <th>Line Commission</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {el.details?.map((inl, index) => (
                                    <tr key={index}>
                                      <td>
                                        <div>{inl.client_name}</div>
                                        <small className="text-muted">
                                          {inl.remarks || "-"}
                                        </small>
                                      </td>
                                      <td>
                                        <div>{inl.package_name || inl.remarks || "-"}</div>
                                        <small className="text-muted">
                                          {inl.package_type || "PT"}
                                        </small>
                                      </td>
                                      <td>
                                        {inl.date_of_joining
                                          ? moment(inl.date_of_joining).format("DD-MM-YYYY")
                                          : "-"}
                                      </td>
                                      <td>
                                        {inl.date_of_expiry
                                          ? moment(inl.date_of_expiry).format("DD-MM-YYYY")
                                          : "-"}
                                      </td>
                                      <td>
                                        {inl.contract_detail || 0}
                                        <div className="text-muted" style={{ fontSize: "11px" }}>
                                          Remaining: {inl.remaining_contract_sessions || 0}
                                        </div>
                                      </td>
                                      <td>{inl.delivered_sessions || inl.sessions_taken || 0}</td>
                                      <td>{inl.client_no_show_count || 0}</td>
                                      <td>{inl.trainer_no_show_count || 0}</td>
                                      <td>{inl.payable_no_show_sessions || 0}</td>
                                      <td>{inl.payable_sessions || 0}</td>
                                      <td>{renderCurrency(inl.package_value_ex_gst || inl.net)}</td>
                                      <td>{renderCurrency(inl.costPerSession)}</td>
                                      <td>{inl.trainer_commission_percent || el.commission_per || 0}%</td>
                                      <td>{renderCurrency(inl.commissionPerSession)}</td>
                                      <td style={{ minWidth: "220px" }}>
                                        <div style={{ fontSize: "12px", fontWeight: 600 }}>
                                          {inl.formula_text ||
                                            `ceil(${inl.commissionPerSession || 0} x ${
                                              inl.payable_sessions || 0
                                            })`}
                                        </div>
                                        <div className="text-muted" style={{ fontSize: "11px" }}>
                                          Delivered {inl.delivered_sessions || inl.sessions_taken || 0} + payable no-show{" "}
                                          {inl.payable_no_show_sessions || 0}
                                        </div>
                                      </td>
                                      <td>{renderCurrency(inl.commission || 0)}</td>
                                      <td>
                                        {inl.is_package_finalized ? (
                                          <span className="badge bg-success w-100">
                                            Completed
                                          </span>
                                        ) : (
                                          <span className="badge bg-warning text-dark w-100">
                                            In Progress
                                          </span>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>

                            <div className="row g-2">
                              <div className="col-md-3">
                                <div className="border rounded p-2 bg-white">
                                  <div style={{ fontSize: "12px", color: "#666" }}>Gross</div>
                                  <div style={{ fontWeight: 700 }}>
                                    {renderCurrency(el.gross_commission || 0)}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="border rounded p-2 bg-white">
                                  <div style={{ fontSize: "12px", color: "#666" }}>Paid</div>
                                  <div style={{ fontWeight: 700 }}>
                                    {renderCurrency(el.paid_commission || 0)}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="border rounded p-2 bg-white">
                                  <div style={{ fontSize: "12px", color: "#666" }}>
                                    Outstanding
                                  </div>
                                  <div style={{ fontWeight: 700 }}>
                                    {renderCurrency(el.outstanding_commission || 0)}
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="border rounded p-2 bg-white">
                                  <div style={{ fontSize: "12px", color: "#666" }}>
                                    Delivered + Paid No-Show
                                  </div>
                                  <div style={{ fontWeight: 700 }}>
                                    {(el.total_delivered_sessions || 0) +
                                      (el.total_payable_no_show_sessions || 0)}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ) : null}
                  </>
                ))
              ) : (
                <tr>
                  {/* //adeel added total sessions and total commision */}
                  <td colSpan="14" className="text-center text-capitalize">
                    No record found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {totalResults > limit && totalPages > 1 ? (
          <Pagination
            activePage={currentPage}
            itemsCountPerPage={parseInt(limit)}
            totalItemsCount={totalResults}
            onChange={(e) => {
              changePagination(e);
            }}
            pageRangeDisplayed={8}
            itemClass="page-item"
            linkClass="page-link"
            firstPageText="First Page"
            lastPageText="Last Page"
          />
        ) : (
          ""
        )}
      </>
    );
  };

  return (
    <div className="wrapper">
      <main className="page-content customer-contnent">
        <div className="site-main-design">
          <MenuButton />
          <div className="card">
            <div className="card-header py-3">
              <h5 className="mb-0 font-20">Staff Commission</h5>
              {/* //adeel */}
              <button
                className="btn btn-primary d-inline-block float-end btn-sm"
                onClick={() => {
                  generatePdf(document.getElementById("report-POS"));
                }}
              >
                <i className="bi bi-file-earmark-pdf float-end"></i> PDF
              </button>
              <a
                href={exportLink}
                rel="noreferrer"
                // target="_blank"
                className="btn btn-primary mx-2 file-download float-end"
              >
                <i className="bi bi-download float-end" /> Excel
              </a>

              {/* //adeel  */}
            </div>
            <div className="card-body">
              <form className="row trainee-add" onSubmit={handleSubmit}>
                {/* <div className="col-md-2">
                  <div className="form-group custom-group">
                    Select Month
                    <select
                      className="form-select"
                      name="sdate"
                      value={values.sdate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option value="01">January</option>
                      <option value="02">February</option>
                      <option value="03">March</option>
                      <option value="04">April</option>
                      <option value="05">May</option>
                      <option value="06">June</option>
                      <option value="07">July</option>
                      <option value="08">August</option>
                      <option value="09">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </select>
                    {errors.sdate && touched.sdate ? (
                      <p className="text-danger">{errors.sdate}</p>
                    ) : null}
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group custom-group">
                    Enter Year
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter End date"
                      name="edate"
                      value={values.edate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.edate && touched.edate ? (
                      <p className="text-danger">{errors.edate}</p>
                    ) : null}
                  </div>
                </div> */}
                <div className="col-md-2">
                  <div className="form-group custom-group">
                    Select Month
                    <select
                      className="form-select"
                      name="sdate"
                      value={values.sdate}
                      onChange={(e) => {
                        handleChange(e);
                        const newMonth = e.target.value;
                        const newPreviousMonth =
                          newMonth === "01"
                            ? "12"
                            : `0${parseInt(newMonth) - 1}`.slice(-2);
                        const newYear =
                          newMonth === "01"
                            ? parseInt(values.edate) - 1
                            : values.edate;
                        setFieldValue(
                          "startdate",
                          `${newYear}-${newPreviousMonth}-26`
                        );
                        setFieldValue(
                          "enddate",
                          `${values.edate}-${newMonth}-25`
                        );
                      }}
                      onBlur={handleBlur}
                    >
                      <option value="01">January</option>
                      <option value="02">February</option>
                      <option value="03">March</option>
                      <option value="04">April</option>
                      <option value="05">May</option>
                      <option value="06">June</option>
                      <option value="07">July</option>
                      <option value="08">August</option>
                      <option value="09">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </select>
                    {errors.sdate && touched.sdate ? (
                      <p className="text-danger">{errors.sdate}</p>
                    ) : null}
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group custom-group">
                    Enter Year
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter Year"
                      name="edate"
                      value={values.edate}
                      onChange={(e) => {
                        handleChange(e);
                        const newYear = e.target.value;
                        const newPreviousMonth =
                          values.sdate === "01"
                            ? "12"
                            : `0${parseInt(values.sdate) - 1}`.slice(-2);
                        const newStartDateYear =
                          values.sdate === "01"
                            ? parseInt(newYear) - 1
                            : newYear;
                        setFieldValue(
                          "startdate",
                          `${newStartDateYear}-${newPreviousMonth}-26`
                        );
                        setFieldValue(
                          "enddate",
                          `${newYear}-${values.sdate}-25`
                        );
                      }}
                      onBlur={handleBlur}
                    />
                    {errors.edate && touched.edate ? (
                      <p className="text-danger">{errors.edate}</p>
                    ) : null}
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group custom-group">
                    From
                    <input
                      type="date"
                      className="form-control"
                      placeholder="date"
                      name="startdate"
                      value={values.startdate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group custom-group">
                    To
                    <input
                      type="date"
                      className="form-control"
                      placeholder="date"
                      name="enddate"
                      value={values.enddate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                </div>

                <div className="col-lg-2">
                  <div className="form-group custom-group">
                    Available Trainers
                    {trainerName ? (
                      <select
                        className="form-select"
                        name="trainer_id"
                        value={values.trainer_id || ""}
                        disabled={role === "9" && UId ? true : false}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                      >
                        {trainerName.map((el, index) => {
                          return (
                            <option key={index} value={el.id}>
                              {el.first_name} {el.last_name}
                            </option>
                          );
                        })}
                      </select>
                    ) : null}
                  </div>
                </div>
                {/* <div className="col-md-2">
                <div className="form-group custom-group">
                  From
                  <input
                    type="date"
                    className="form-control"
                    placeholder="date"
                    name="startdate"
                    value={values.sdate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </div>
                </div>
                <div className="col-md-2">
                <div className="form-group custom-group">
                  To
                  <input
                    type="date"
                    className="form-control"
                    placeholder="date"
                    name="enddate"
                    value={values.edate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </div>
                </div> */}
                <div className="col-12 col-md-1">
                  <button
                    type="submit"
                    className="btn btn-primary d-inline-block mt-4"
                  >
                    Generate
                  </button>
                </div>
                <div className="col-md-1 col-lg-1 mt-4 ms-auto">
                  <div className="input-group">
                    <select
                      className="form-select"
                      value={limit}
                      onChange={(e) => changeLimit(e.target.value)}
                    >
                      <option value="10">10</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="250">250</option>
                      <option value="500">500</option>
                    </select>
                  </div>
                </div>

                <div className=" col-md-2 text-end mt-4">
                  {/* <a
                    href={exportLink}
                    rel="noreferrer"
                    // target="_blank"
                    className="btn btn-primary mx-2 file-download"
                  >
                    <i className="bi bi-download" /> Excel
                  </a> */}
                </div>
              </form>
              <div className="mt-2 mb-1 text-muted">
                Period:{" "}
                {periodRange.start_date
                  ? moment(periodRange.start_date).format("DD-MM-YYYY")
                  : "-"}{" "}
                to{" "}
                {periodRange.end_date
                  ? moment(periodRange.end_date).format("DD-MM-YYYY")
                  : "-"}
              </div>
              <div className="mb-2" style={{ fontSize: "13px" }}>
                <span className="badge bg-success me-2">Green = fully paid</span>
                <span className="badge bg-warning text-dark">
                  Yellow = half/partial paid
                </span>
              </div>
              <Table data={myData} rowsPerPage={limit} />
            </div>
          </div>
        </div>
      </main>
      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>
    </div>
  );
};

export default StaffCommision;
